import { Imagem } from 'components/images';
import { useClientContext } from 'context/ClientContext';
import { useImage } from 'hooks/useImage';

export const Logo = () => {
    const { logo, documentTitle } = useClientContext();
    const { loading, image } = useImage(logo);

    return <>{!loading && <Imagem src={image} alt={documentTitle} />}</>;
};
